export default __webpack_public_path__ + "zoom-in.f512af0bc0782dda.svg";